<template lang="pug">
    article#pagina
        component(:is="item.component", v-for="item, index in mappedContents", :key="`${index}-${item.content.type}`", v-bind="item.content")
        AsideImage(v-if="hasAsideImage")
        AsideVideo(v-if="hasAsideVideo")
</template>

<script>
import pagina from '@/mixins/pagina'
import Banner from '@sections/Pagina/Banner/Banner'

export default {
    name: "view-pagina",
    mixins: [ pagina ],
    components: {
        Banner,
    },
}
</script>

<style lang="stylus" scoped src="./Pagina.styl"></style>